module.exports = __webpack_public_path__ + "static/media/paymentLinks.41f42365.svg";